import React from "react";
import { OrganizationDataRecipientDto } from "../../../../../../common/service/server/dto/OrganizationDataRecipientDto";
import {
  groupAndSortVendorsByCategory,
  getCategoryGroupOrder,
} from "../../../../../util/vendorCategorization";
import { CategoryHeader } from "./CategoryHeader";

interface CategorizedVendorListProps {
  vendors: OrganizationDataRecipientDto[];
  renderVendor: (
    vendor: OrganizationDataRecipientDto,
    isLast: boolean,
    isFirstInCategory: boolean,
  ) => React.ReactNode;
}

export const CategorizedVendorList = ({ vendors, renderVendor }: CategorizedVendorListProps) => {
  const groupedVendors = groupAndSortVendorsByCategory(vendors);
  const sortedGroupNames = Object.keys(groupedVendors).sort((a, b) => {
    return getCategoryGroupOrder(a) - getCategoryGroupOrder(b);
  });

  return (
    <>
      {sortedGroupNames.map((categoryName, groupIndex) => {
        const categoryVendors = groupedVendors[categoryName];
        if (categoryVendors.length === 0) return null;

        return (
          <div key={categoryName}>
            <CategoryHeader categoryName={categoryName} />
            {categoryVendors.map((vendor, vendorIndex) => {
              const isLastInCategory = vendorIndex === categoryVendors.length - 1;
              const isLastOverall = groupIndex === sortedGroupNames.length - 1 && isLastInCategory;
              const isFirstInCategory = vendorIndex === 0;

              return (
                <div key={vendor.id}>
                  {renderVendor(vendor, isLastOverall, isFirstInCategory)}
                  {!isLastInCategory && (
                    <div
                      style={{
                        margin: "0 16px",
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};
